/*
 * File: slack.service.ts
 * Project: a-a
 * File Created: Friday, 1st August 2025 9:49:49 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 7th January 2026 8:48:57 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';

import { ApiConstants } from './api-constants';

export class SlackService {
  static getSlackLogin = async (code: string) => {
    return await (
      await axios.get(ApiConstants.SLACK_API.SLACK_LOGIN.URL(code))
    ).data;
  };

  static getSlackChannelMessages = async (channelId: string = '', next?: string) => {
    return await (
      await axios.get(ApiConstants.SLACK_API.SLACK_CHANNEL_MESSAGE.URL(channelId, next))
    ).data;
  };
  static getSlackChannels = async () => {
    return await (
      await axios.get(ApiConstants.SLACK_API.SLACK_CHANNELS.URL())
    ).data;
  };
  static unlinkSlack = async (body: any) => {
    return await (
      await axios.patch(ApiConstants.SLACK_API.SLACK_UNLINK.URL())
    ).data;
  };
}
